import {useImageryPrices} from 'app/providers/ImageryPricesProvider';
import * as conversionUtils from 'app/utils/conversionUtils';

export function calculateCost(acres: number, pricePerAcre: number): number {
  return acres * pricePerAcre;
}

export function formatCost(cents: number) {
  return `$${conversionUtils.numberWithCommas((cents / 100).toFixed(2))}`;
}

export const usePerAcrePrice = (sourceId: string) => {
  const {prices: imageryPrices} = useImageryPrices();
  return imageryPrices[sourceId];
};
